"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../Icon"));
var MaterialIcon_1 = __importDefault(require("../MaterialIcon"));
var Spinner_1 = __importDefault(require("./Spinner"));
var utils_1 = require("./utils");
var styles_1 = require("./styles");
var Button = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.variant, variant = _c === void 0 ? 'secondary' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, iconName = _a.iconName, iconSide = _a.iconSide, iconOnly = _a.iconOnly, _e = _a.isMaterialIcon, isMaterialIcon = _e === void 0 ? false : _e, children = _a.children, loading = _a.loading, props = __rest(_a, ["size", "variant", "fullWidth", "iconName", "iconSide", "iconOnly", "isMaterialIcon", "children", "loading"]);
    var VariantComponent = (0, utils_1.getVariantComponent)(variant);
    var content = null;
    var iconElement = isMaterialIcon ? ((0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: iconName, size: size })) : ((0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName, size: size }));
    if (iconName && iconSide) {
        content = ((0, jsx_runtime_1.jsxs)(styles_1.ButtonContent, __assign({ iconSide: iconSide }, { children: [children, (0, jsx_runtime_1.jsx)(styles_1.IconContainer, __assign({ iconSide: iconSide, size: size }, { children: iconElement }))] })));
    }
    else if (iconOnly && iconName) {
        content = ((0, jsx_runtime_1.jsx)(styles_1.ButtonContent, { children: (0, jsx_runtime_1.jsx)(styles_1.IconContainer, __assign({ size: size }, { children: iconElement })) }));
    }
    else {
        content = children;
    }
    return ((0, jsx_runtime_1.jsx)(VariantComponent, __assign({}, props, { size: size, className: (0, classnames_1.default)({
            FullWidth: fullWidth,
            IconOnly: iconOnly,
            right: iconSide === 'right',
            left: iconSide === 'left',
        }), disabled: loading || props.disabled }, { children: loading ? (0, jsx_runtime_1.jsx)(Spinner_1.default, { variant: variant }) : content })));
};
exports.default = Button;
